export default __webpack_public_path__ + "static/media/ic-delete.17e52339.svg";